module.exports = __webpack_public_path__ + "1050a229c6222a504f72b0cd57fcc7ef.svg";